import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postPromotionRedemptionCancel } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { promotionsKeyFn, promotionsRedemptionKeyFn } from './rewards.keys';

interface CancelRequestBody extends Rewards.PromotionCancelRedemptionRequest {
  uuid: string;
}

export function usePostPromotionRedemptionCancelMutation(
  options?: UseMutationOptions<Rewards.PromotionRedemption, CancelRequestBody>
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ uuid, ...promotionCancelRedemptionRequest }) =>
      postPromotionRedemptionCancel(uuid, promotionCancelRedemptionRequest),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        const { uuid } = data;

        queryClient.setQueryData(promotionsRedemptionKeyFn(uuid), data);

        queryClient.invalidateQueries(promotionsKeyFn());

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
}
